import React from 'react';
import { Popconfirm } from 'antd';
import { DeleteOutlined, CheckOutlined } from '@ant-design/icons';

import ButtonWithRole from './ButtonWithRole';
import { CONTENT_WRITE_REFUSED_ROLES } from '../features/auth/roleCapabilities';
import { TOOLTIP_ROOT_ID } from './Tooltip';

export const DeletePageButton = ({ disabled, tooltip = 'Remove the URL from the cache', onClick }) => (
  <Popconfirm
    title="Are you sure you want to delete this URL?"
    placement="left"
    onConfirm={onClick}
    okText="Yes"
    cancelText="Cancel"
  >
    <div data-tooltip-id={TOOLTIP_ROOT_ID} data-tooltip-place="top" data-tooltip-content={tooltip}>
      <ButtonWithRole
        disabledFor={CONTENT_WRITE_REFUSED_ROLES}
        className="ml-2"
        danger
        disabled={disabled}
        data-tip={tooltip}
        icon={<DeleteOutlined />}
      ></ButtonWithRole>
    </div>
  </Popconfirm>
);

// This is for the ignored URLs
export const SaveButton = ({ disabled, tooltip, onClick }) => (
  <ButtonWithRole
    disabledFor={CONTENT_WRITE_REFUSED_ROLES}
    className="ml-2"
    type="primary"
    ghost
    danger={false}
    disabled={disabled}
    onClick={onClick}
    data-tip={tooltip}
    icon={<CheckOutlined />}
  ></ButtonWithRole>
);
